









































































import { Component, Vue, Prop } from 'vue-property-decorator';
import {
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality,
  GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality_employerTaxZone,
} from '@/queries/__generated__/ameldingNewData';
import { AdditionalField } from './AmeldingForm.vue';

@Component({
  components: {
  },
})
export default class AmeldingFormAdditionalFields extends Vue {
  @Prop({ type: Array, required: true }) private additionalFields!: AdditionalField[];
  @Prop({ type: Array, required: true }) private selectedMunicipalities!: GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality[];
  @Prop({ type: Array, required: true }) private selectedEmployerTaxZones!: GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality_employerTaxZone[];

  private zone(id: string): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality_employerTaxZone {
    return this.selectedEmployerTaxZones.find(z => z.id === id)!;
  }

  private municipalities(employerTaxZoneId: string): GQL_ameldingNewData_currentUnit_subUnits_workRelations_paychecksForAmelding_companyMunicipality[] {
    return this.selectedMunicipalities
      .filter(m => m.employerTaxZone.id === employerTaxZoneId);
  }

  private municipalitiesList(employerTaxZoneId: string): string {
    return this.municipalities(employerTaxZoneId)
      .slice(0, 3) // to prevent zones taking up all the space on the page
      .map(m => `${m.number} ${m.name}`)
      .concat(this.municipalities(employerTaxZoneId).length > 3 ? [ '...' ] : [])
      .join(', ');
  }

  private translate(key: string, options: object) {
    return this.$t(`Amelding.AdditionalFields.${key}`, options);
  }
}
